export const logoBaseURL = 'https://logo.ignosis.ai/';
export const isLogEnabled =
  process.env.REACT_APP_CONSOLE_LOGS_ENABLED === 'true';
export const prefix = process.env.REACT_APP_PREFIX;

export enum PortfolioTyoe {
  Banks,
  MF,
  Stocks,
  Deposits,
}

export enum FlowType {
  STOCKS,
  BANKS,
  MUTUAL_FUNDS,
  TERM_DEPOSITS,
}

export enum SdkFlowSelection {
  SHOW_FIP_SELECTION = 'SHOW_FIP_SELECTION',
}

export interface FIP {
  enabled?: string;
  id: string;
  name: string;
  altNames?: string[];
}
